"use client"
import React, { useState, useEffect } from 'react'
import { IoSearch } from "react-icons/io5";
import { Oswald } from 'next/font/google';
import Image from 'next/image';
import Link from 'next/link';
import Footer from '@/components/footer/page';
import Header from '@/components/header2/page';
import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation';
import BottomFooter from '@/components/BottomFooter/BottomFooter';
import { useAppSelector } from "@/redux/store";
import { GoArrowLeft } from "react-icons/go";
import { useRouter, usePathname } from 'next/navigation'
import { Roboto } from 'next/font/google';
import { Fredoka } from "next/font/google";
const oswalds = Oswald({ subsets: ['latin'] })
const roboto = Roboto({ weight: ['700',], subsets: ['latin'] })
const fredoka = Fredoka({ subsets: ["latin"] });

interface Params {
    slug: string;
}

const links = [
    {
        id: 1,
        title: "Concerts",
        teams: [],
    },
    {
        id: 3,
        title: "nfl",
        teams: [
            { name: "Buffalo Bills", slug: "buffalo-bills" },
            { name: "Arizona Cardinals", slug: "arizona-cardinals" },
            { name: "Atlanta Falcons", slug: "atlanta-falcons" },
            { name: "Baltimore Ravens", slug: "baltimore-ravens" },
            { name: "Carolina Panthers", slug: "carolina-panthers" },
            { name: "Chicago Bears", slug: "chicago-bears" },
            { name: "Cincinnati Bengals", slug: "cincinnati-bengals" },
            { name: "Cleveland Browns", slug: "cleveland-browns" },
            { name: "Dallas Cowboys", slug: "dallas-cowboys" },
            { name: "Denver Broncos", slug: "denver-broncos" },
            { name: "Detroit Lions", slug: "detroit-lions" },
            { name: "Green Bay Packers", slug: "green-bay-packers" },
            { name: "Houston Texans", slug: "houston-texans" },
            { name: "Indianapolis Colts", slug: "indianapolis-colts" },
            { name: "Jacksonville Jaguars", slug: "jacksonville-jaguars" },
            { name: "Kansas City Chiefs", slug: "kansas-city-chiefs" },
            { name: "Las Vegas Raiders", slug: "las-vegas-raiders" },
            { name: "Los Angeles Chargers", slug: "los-angeles-chargers" },
            { name: "Los Angeles Rams", slug: "los-angeles-rams" },
            { name: "Miami Dolphins", slug: "miami-dolphins" },
            { name: "Minnesota Vikings", slug: "minnesota-vikings" },
            { name: "New England Patriots", slug: "new-england-patriots" },
            { name: "New Orleans Saints", slug: "new-orleans-saints" },
            { name: "New York Giants", slug: "new-york-giants" },
            { name: "New York Jets", slug: "new-york-jets" },
            { name: "Philadelphia Eagles", slug: "philadelphia-eagles" },
            { name: "Pittsburgh Steelers", slug: "pittsburgh-steelers" },
            { name: "San Francisco 49ers", slug: "san-francisco-49ers" },
            { name: "Seattle Seahawks", slug: "seattle-seahawks" },
            { name: "Tampa Bay Buccaneers", slug: "tampa-bay-buccaneers" },
            { name: "Tennessee Titans", slug: "tennessee-titans" },
            { name: "Washington Commanders", slug: "washington-commanders" }
        ]
    },
    {
        id: 4,
        title: "mlb",
        teams: [
            { name: "Toronto Blue Jays", slug: "toronto-blue-jays" },
            { name: "Arizona Diamondbacks", slug: "arizona-diamondbacks" },
            { name: "Atlanta Braves", slug: "atlanta-braves" },
            { name: "Baltimore Orioles", slug: "baltimore-orioles" },
            { name: "Boston Red Sox", slug: "boston-red-sox" },
            { name: "Chicago White Sox", slug: "chicago-white-sox" },
            { name: "Chicago Cubs", slug: "chicago-cubs" },
            { name: "Cincinnati Reds", slug: "cincinnati-reds" },
            { name: "Cleveland Guardians", slug: "cleveland-guardians" },
            { name: "Colorado Rockies", slug: "colorado-rockies" },
            { name: "Detroit Tigers", slug: "detroit-tigers" },
            { name: "Houston Astros", slug: "houston-astros" },
            { name: "Kansas City Royals", slug: "kansas-city-royals" },
            { name: "Los Angeles Angels", slug: "los-angeles-angels" },
            { name: "Los Angeles Dodgers", slug: "los-angeles-dodgers" },
            { name: "Miami Marlins", slug: "miami-marlins" },
            { name: "Milwaukee Brewers", slug: "milwaukee-brewers" },
            { name: "Minnesota Twins", slug: "minnesota-twins" },
            { name: "New York Yankees", slug: "new-york-yankees" },
            { name: "New York Mets", slug: "new-york-mets" },
            { name: "Oakland Athletics", slug: "oakland-athletics" },
            { name: "Philadelphia Phillies", slug: "philadelphia-phillies" },
            { name: "Pittsburgh Pirates", slug: "pittsburgh-pirates" },
            { name: "San Diego Padres", slug: "san-diego-padres" },
            { name: "San Francisco Giants", slug: "san-francisco-giants" },
            { name: "Seattle Mariners", slug: "seattle-mariners" },
            { name: "St. Louis Cardinals", slug: "st-louis-cardinals" },
            { name: "Tampa Bay Rays", slug: "tampa-bay-rays" },
            { name: "Texas Rangers", slug: "texas-rangers" },
            { name: "Washington Nationals", slug: "washington-nationals" }], // Replace with actual team names
    },
    {
        id: 5,
        title: "nba",
        teams: [
            { name: "Toronto Raptors", slug: "toronto-raptors" },
            { name: "Atlanta Hawks", slug: "atlanta-hawks" },
            { name: "Boston Celtics", slug: "boston-celtics" },
            { name: "Brooklyn Nets", slug: "brooklyn-nets" },
            { name: "Charlotte Hornets", slug: "charlotte-hornets" },
            { name: "Chicago Bulls", slug: "chicago-bulls" },
            { name: "Cleveland Cavaliers", slug: "cleveland-cavaliers" },
            { name: "Dallas Mavericks", slug: "dallas-mavericks" },
            { name: "Denver Nuggets", slug: "denver-nuggets" },
            { name: "Detroit Pistons", slug: "detroit-pistons" },
            { name: "Golden State Warriors", slug: "golden-state-warriors" },
            { name: "Houston Rockets", slug: "houston-rockets" },
            { name: "Indiana Pacers", slug: "indiana-pacers" },
            { name: "Los Angeles Clippers", slug: "los-angeles-clippers" },
            { name: "Los Angeles Lakers", slug: "los-angeles-lakers" },
            { name: "Memphis Grizzlies", slug: "memphis-grizzlies" },
            { name: "Miami Heat", slug: "miami-heat" },
            { name: "Milwaukee Bucks", slug: "milwaukee-bucks" },
            { name: "Minnesota Timberwolves", slug: "minnesota-timberwolves" },
            { name: "New Orleans Pelicans", slug: "new-orleans-pelicans" },
            { name: "New York Knicks", slug: "new-york-knicks" },
            { name: "Oklahoma City Thunder", slug: "oklahoma-city-thunder" },
            { name: "Orlando Magic", slug: "orlando-magic" },
            { name: "Philadelphia 76ers", slug: "philadelphia-76ers" },
            { name: "Phoenix Suns", slug: "phoenix-suns" },
            { name: "Portland Trail Blazers", slug: "portland-trail-blazers" },
            { name: "Sacramento Kings", slug: "sacramento-kings" },
            { name: "San Antonio Spurs", slug: "san-antonio-spurs" },
            { name: "Utah Jazz", slug: "utah-jazz" },
            { name: "Washington Wizards", slug: "washington-wizards" }]
    },
    {
        id: 6,
        title: "nhl",
        teams: [
            { name: "Toronto Maple Leafs", slug: "toronto-maple-leafs" },
            { name: "Anaheim Ducks", slug: "anaheim-ducks" },
            { name: "Arizona Coyotes", slug: "arizona-coyotes" },
            { name: "Boston Bruins", slug: "boston-bruins" },
            { name: "Buffalo Sabres", slug: "buffalo-sabres" },
            { name: "Calgary Flames", slug: "calgary-flames" },
            { name: "Carolina Hurricanes", slug: "carolina-hurricanes" },
            { name: "Chicago Blackhawks", slug: "chicago-blackhawks" },
            { name: "Colorado Avalanche", slug: "colorado-avalanche" },
            { name: "Columbus Blue Jackets", slug: "columbus-blue-jackets" },
            { name: "Dallas Stars", slug: "dallas-stars" },
            { name: "Detroit Red Wings", slug: "detroit-red-wings" },
            { name: "Edmonton Oilers", slug: "edmonton-oilers" },
            { name: "Florida Panthers", slug: "florida-panthers" },
            { name: "Los Angeles Kings", slug: "los-angeles-kings" },
            { name: "Minnesota Wild", slug: "minnesota-wild" },
            { name: "Montreal Canadiens", slug: "montreal-canadiens" },
            { name: "Nashville Predators", slug: "nashville-predators" },
            { name: "New Jersey Devils", slug: "new-jersey-devils" },
            { name: "New York Islanders", slug: "new-york-islanders" },
            { name: "New York Rangers", slug: "new-york-rangers" },
            { name: "Ottawa Senators", slug: "ottawa-senators" },
            { name: "Philadelphia Flyers", slug: "philadelphia-flyers" },
            { name: "Pittsburgh Penguins", slug: "pittsburgh-penguins" },
            { name: "San Jose Sharks", slug: "san-jose-sharks" },
            { name: "St. Louis Blues", slug: "st-louis-blues" },
            { name: "Tampa Bay Lightning", slug: "tampa-bay-lightning" },
            { name: "Vancouver Canucks", slug: "vancouver-canucks" },
            { name: "Vegas Golden Knights", slug: "vegas-golden-knights" },
            { name: "Washington Capitals", slug: "washington-capitals" },
            { name: "Winnipeg Jets", slug: "winnipeg-jets" }], // Replace with actual team names
    },
    {
        id: 7,
        title: "more",
        teams: [{ name: "Newsletter", slug: "/newsletter" }, { name: "Buy Razzal", slug: "https://razilia.com/" }, { name: "Contact Us", slug: "/contactus" }],
    },
];

const Page = ({ params }: { params: Params }) => {
    const { slug } = params;
    let mainteam = links.find((team) => team.title === slug);
    // console.log(mainteam);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [filteredTeams, setFilteredTeams] = useState<Array<string | { name: string; slug: string; }>>(mainteam?.teams || []);
    const uppercaseSlug = slug.toUpperCase();
    const [loading, setLoading] = useState(false);
    // console.log(slug)
    useEffect(() => {
        setFilteredTeams(
            (mainteam?.teams || []).filter((team: string | { name: string; slug: string; }) =>
                typeof team === 'string' ? team.toLowerCase().includes(searchTerm.toLowerCase()) : team.name.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [mainteam, searchTerm]);

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
    };
    const colors = ['blue', 'orange', 'green', 'purple'];
    const getRandomColor = () => {
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
    };

    const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);

    const router = useRouter();

    const handleBackClick = () => {
        router.back();
    };

    return (
        <div className='flex flex-col min-h-screen'>
            {
                (loading) &&
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 bg-white w-screen h-screen">
                    <div className='w-full h-full absolute flex items-center justify-center text-black'><LoadingAnimation /></div>
                </div>
            }

            {!isPWA && (
                <Header heading={{ head: uppercaseSlug, slug: slug }} loading={loading} setLoading={setLoading} />
            )}

            {isPWA && (
                <div className='mt-[10px]'>
                    <div className='flex space-x-2 w-[90%] mx-auto mb-3 mt='>
                        <button onClick={handleBackClick}>
                            <GoArrowLeft className="text-black text-center h-8 w-8" />
                        </button>
                        <div className='flex'>
                            <div className={`${roboto.className} font-normal text-xl text-center text-black`}>Sports |&nbsp;</div>
                            <div className={`${roboto.className} font-normal text-xl text-center text-black`}>{slug.toUpperCase()}</div>
                        </div>
                    </div>
                    <div className="flex justify-center items-center w-[90%] rounded-full bg-[#EBEDF0] mx-auto">
                        <IoSearch className="h-10 w-6 mx-2 my-1" />
                        <input
                            type="text"
                            className="w-full h-10 bg-[#EBEDF0] outline-none text-gray-700 rounded-full placeholder-gray-700"
                            placeholder="Search by teams"
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                    </div>
                    <div className={`w-[90%] mx-auto text-3xl font-medium leading-6 text-left mb-4 mt-6 ${fredoka.className}`}>Tickets by Teams</div>
                </div>
            )}

            <div className={`flex-grow ${!isPWA ? 'py-10' : ''} bg-[#fafbfb] flex justify-center`}>
                <div className='flex flex-col justify-center w-11/12'>
                    <div className="flex flex-col gap-6 h-full">
                        {!isPWA && (
                            <>
                                <h1 className={`font-medium text-4xl ${oswalds.className}`}>TICKETS BY TEAMS</h1>
                                <div className="flex items-center w-full min-[375px]:w-80 border-2 border-neutral-400 rounded-2xl bg-white">
                                    <IoSearch className="h-6 w-6 mx-2 my-1" />
                                    <input
                                        type="text"
                                        className="w-full outline-none text-sm text-gray-700 max-md:text-[13px] placeholder-gray-700"
                                        placeholder="Search by teams"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </div>
                            </>
                        )}
                        <div className="flex flex-col flex-grow">
                            {/* <div className="flex flex-row flex-wrap justify-evenly gap-3"> */}
                            <div className={`${!isPWA ? 'flex flex-row flex-wrap justify-evenly gap-3' : 'flex flex-col gap-3'}`}>
                                {filteredTeams.length > 0 ? (
                                    filteredTeams.map((team: any, index: number) => {
                                        const color = getRandomColor();
                                        return (
                                            <div key={index} onClick={() => setLoading(true)}>
                                                <Link
                                                    href={
                                                        mainteam?.title === "more"
                                                            ? `/${team.slug}`
                                                            : `/top-teams/${team.slug}?mainteam=${encodeURIComponent(JSON.stringify(mainteam))}`
                                                    }
                                                >
                                                    <div
                                                        className={` ${!isPWA ? 'w-64 min-[375px]:w-80' : ''
                                                            } h-32 border-2 rounded-lg flex transition duration-300 hover:shadow-sm hover:scale-[1.02] cursor-pointer ${color === 'orange'
                                                                ? 'border-orange-500'
                                                                : color === 'purple'
                                                                    ? 'border-purple-500'
                                                                    : color === 'blue'
                                                                        ? 'border-blue-500'
                                                                        : color === 'green'
                                                                            ? 'border-green-500'
                                                                            : ''
                                                            }`}
                                                    >
                                                        <div className="w-9/12 flex flex-col h-full relative pl-3 justify-center items-start">
                                                            <div className="flex flex-col justify-start">
                                                                <h1 className="text-lg font-bold">{team.name}</h1>
                                                                {mainteam?.title !== 'more' ? <h2>see tickets</h2> : null}
                                                            </div>
                                                        </div>
                                                        <Image
                                                            src={`/texture-${color}.svg`}
                                                            alt="texture"
                                                            width={50}
                                                            height={50}
                                                            className="w-3/12"
                                                        />
                                                    </div>
                                                </Link>

                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center text-gray-500">No teams available</div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {isPWA && (
                <><br /><br /><br /><br /></>
            )}
            <div className='className="flex-shrink-0"'>
                {/* <Footer  /> */}
                <BottomFooter />

            </div>

        </div>
    )
}

export default Page